import pdfMake, { userMark, setMyConfig, makeTableContent } from "@/utils/pdf";

function pdfReporteAgencia(payload) {
  const columns = [
    {
      key: "tabla",
      label: "Tabla",
      width: "auto",
    },
    {
      key: "codigo",
      label: "Cód.",
      width: "auto",
    },
    {
      key: "fecha",
      label: "Fecha",
      width: "auto",
    },
    {
      key: "pasajero",
      label: "Pasajero",
      width: "*",
    },
    {
      key: "servicio",
      label: "Servicio",
      width: "auto",
    },
    {
      key: "tipoServicio",
      label: "Tipo Servicio",
      width: "auto",
    },
    {
      key: "pax",
      label: "PAX",
      width: "auto",
    },
    {
      key: "chd",
      label: "CHD",
      width: "auto",
    },
    {
      key: "fecha",
      label: "Fecha",
      width: "auto",
    },
    {
      key: "idioma",
      label: "Idioma",
      width: "auto",
    },
    {
      key: "codLiquidacion",
      label: "Cód. Liquid.",
      width: "auto",
    },
    {
      key: "costoLiquidacion",
      label: "Costo Liquid.",
      width: "auto",
    },
    {
      key: "usuarioCreador",
      label: "U. Creador",
      width: "auto",
    },
  ];

  const table = makeTableContent([...payload.registros], columns);

  pdfMake
    .createPdf({
      info: {
        title: `Reporte de Agencias`,
      },
      content: [
        {
          text: "Reporte de Agencias",
          style: "h1",
        },
        {
          columns: [
            {
              text: `Agencia: ${payload.header.agencia}`,
              width: "auto",
            },
            {
              text: `Fecha Inicio: ${payload.header.fecha_inicio}`,
              width: "auto",
            },
            {
              text: `Fecha Fin: ${payload.header.fecha_fin}`,
              width: "auto",
            },
            // {
            //   text: `Usuario: ${payload.header.usuario}`,
            //   width: "auto",
            // },
          ],
          margin: [0, 0, 0, 5],
        },
        table,
        ...userMark(payload.userMark, payload.dateMark),
      ],
      ...setMyConfig(),
    })
    .print();
}

export default pdfReporteAgencia;
